import React, { useState } from 'react';
import { Text, TouchableOpacity, View } from 'react-native';
import { styles } from './AppStyles';

export const HomeButton = ({ index, title, progressText, progressTextColor, onPress, color }) => {
  return (
    <TouchableOpacity onPress={onPress}>
      <View style={{
          backgroundColor: color,
          padding: 15,
          marginVertical: 0,
          marginHorizontal: 0,
          minHeight: 69,
          borderRadius: 5,
          elevation: 0,
          flex: 1,
          flexDirection: 'row',
          alignContent: 'center',
          justifyContent: 'center',
          transform: [{ perspective: 1000 }, { rotateX: '2deg' }],
        }}
      >
        <View style={styles.deckInfo}>
          <Text style={styles.deckName}>Deck {index}</Text>
          <Text style={styles.deckGroup}>{title}</Text>
        </View>
        <View style={styles.progressInfo}>
          <Text style={[styles.deckProgress, { color: progressTextColor }]}>{progressText}</Text>
        </View>
      </View>
    </TouchableOpacity>
  );
};

export const CorrectButton = ({ onPress }) => {

  return (
    <TouchableOpacity
      onPress={onPress}
      activeOpacity={1}
      style={{
        borderColor: '#41ad49',
        backgroundColor: '#41ad49',
        borderWidth: 2,
        width: 50,
        height: 50,
        borderRadius: 25,
        alignItems: 'center',
        justifyContent: 'center',
        margin: 5,
      }}>
      <Text style={{ color: 'white', fontSize: 24 }}>
        &#10003;
      </Text>
    </TouchableOpacity>
  );
};

export const WrongButton = ({ onPress }) => {

  return (
    <TouchableOpacity
      onPress={onPress}
      activeOpacity={1}
      style={{
        borderColor: '#d1444a',
        backgroundColor: '#d1444a',
        borderWidth: 2,
        width: 50,
        height: 50,
        borderRadius: 25,
        alignItems: 'center',
        justifyContent: 'center',
        margin: 5,
      }}>
      <Text style={{ color: 'white', fontSize: 24 }}>
        &#10005;
      </Text>
    </TouchableOpacity>
  );
};

  export const ToggleButton = ({ title, onPress }) => {
    return (
      <TouchableOpacity onPress={onPress} style={{
        backgroundColor: '#d97d27',
        paddingHorizontal: 20,
        paddingVertical: 10,
        borderRadius: 20, // this gives the oval shape
        alignItems: 'center',
        justifyContent: 'center'
        // margin: 5
      }}>
        <Text style={{ color: 'white', textTransform: 'uppercase' }}>{title}</Text>
      </TouchableOpacity>
    );
  };